import React from 'react'

import { trackedClick, serialize } from '../utils'

const EMAIL = 'hello@inten.to'

const MailToLink = ({
    title,
    content = 'I really like your product!',
    children,
    source,
}) => {
    let mailtoUrl = `mailto:${EMAIL}`
    const letter = {
        subject: title || 'Feedback from Intento Web',
        body: `Dear Intento, \n\n\n${content}\n\n\nBest regards,\n`,
    }
    mailtoUrl = `mailto:${EMAIL}? ${serialize(letter)}`

    return (
        <a
            href={mailtoUrl}
            onClick={trackedClick('Mailto link clicked', {
                source: source || 'Mailto link',
                title,
            })}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children || EMAIL}
        </a>
    )
}

export default MailToLink



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/MailToLink.jsx